import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiUrl } from '../../custom-services/api-url/api-url';
import { ApiService } from '../../custom-services/ApiService';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environments/environment';
import { CommaSeparatorService } from '../../service/comma-separator.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonUtilService } from '../../service/utils/common-utils';
import { MultiApiService } from '../../custom-services/multi-api.service';
import { DataService } from '../../service/data.service';
import { SECTION_CONSTANTS } from "../../constants/global-constant";
@Component({
    selector: 'app-income-tax-certificate',
    templateUrl: './income-tax-certificate.component.html',
    styleUrls: ['./income-tax-certificate.component.css'],
    standalone: false
})
export class IncomeTaxCertificateComponent implements OnInit, OnDestroy {
    @ViewChild('taxInfoModal')
    taxInfoModal: TemplateRef<any>;
    @ViewChild('pendingStatusModal')
    pendingStatusModal: TemplateRef<any>;
    @ViewChild('nullStatusModal')
    nullStatusModal: TemplateRef<any>;
    @ViewChild('infoMismatchModal')
    infoMismatchModal: TemplateRef<any>;
    @Input()
    isArchive: Boolean = false;
    @Input()
    year: String = '';
    @Input()
    type: String = '';
    apiService: ApiService;
    apiUrl: ApiUrl;
    checkIsTokenExpired: any;
    userTin: any;
    minDate = new Date();
    maxDate = new Date();
    defaultTodaysDate = new Date();
    defaultDateInString: any;
    isShow: any;
    status: string;
    todaysDate: any;
    taxpayerQRData: string = null;
    incomeCheckBox: boolean = false;
    netCheckBox: boolean = false;
    taxCheckBox: boolean = false;
    returnResponse: any;
    totalAmount: string;
    totalTaxAmount: string;
    netWealthAmount: string;
    taxZones: any;
    taxCircles: any;
    initFormValue: any;
    modalRef: BsModalRef;
    prevInputValues = {
        totalIncome: '',
        netWealth: '',
        paidTax: ''
    };
    section: any;
    isPublicUrl: boolean;
    uniqueKey: string;
    isApiLoading: boolean = false;
    pathBaseUrl: string = environment.production ? 'https://etaxnbr.gov.bd/#/' : 'https://staging.etaxnbr.gov.bd/#/';
    listOfUniqueKeys: any[] = [];
    constructor(private router: Router, apiService: ApiService, apiUrl: ApiUrl, private toastr: ToastrService, private sanitizer: DomSanitizer, private datepipe: DatePipe, private httpClient: HttpClient, private jwtHelper: JwtHelperService, private commaseparator: CommaSeparatorService, private modalService: BsModalService, private datePipe: DatePipe, private multiApiService: MultiApiService, private dataSource: DataService, private route: ActivatedRoute) {
        this.apiService = apiService;
        this.apiUrl = apiUrl;
    }
    taxInfoForm = new UntypedFormGroup({
        totalIncome: new UntypedFormControl('', [Validators.required]),
        netWealth: new UntypedFormControl('', [Validators.required]),
        paidTax: new UntypedFormControl('', [Validators.required]),
        returnRegSerial: new UntypedFormControl('', [Validators.required]),
        submissionDate: new UntypedFormControl('', [Validators.required]),
        submissionSection: new UntypedFormControl('0', [Validators.required]),
        taxZone: new UntypedFormControl(0, [Validators.required]),
        taxCircle: new UntypedFormControl(0, [Validators.required])
    });
    ngOnInit(): void {
        this.isPublicUrl = this.route.snapshot.url[0].path === 'tax-certificate' ? true : false;
        this.uniqueKey = this.route.snapshot.queryParams['key'];
        this.initFormValue = this.taxInfoForm.value;
        if (this.isPublicUrl) {
            this.getPublicTaxCertificateData();
        } else {
            this.handlePrivateTaxCertificate();
        }
    }

    handlePrivateTaxCertificate() {
        if (localStorage.getItem('token')) {
            this.checkIsTokenExpired = this.jwtHelper.isTokenExpired(localStorage.getItem('token'));
        }
        if (this.checkIsTokenExpired) {
            localStorage.clear();
            this.router.navigate(["/auth/sign-in"]);
        }
        if (!this.checkIsTokenExpired) {
            this.userTin = localStorage.getItem('tin');
            this.todaysDate = this.datepipe.transform(this.defaultTodaysDate, 'dd MMMM yyyy');
            this.defaultDateInString = this.datepipe.transform(this.defaultTodaysDate, 'dd/MM/yyyy');
            this.getZones();
            this.checkSubmissionStatus();
        }
        this.dataSource.data$.subscribe(data => {
            const currentAssessmentYearStart = data.get('CURRENT_ASSESSMENT_YEAR')?.split('-')[0];
            this.minDate = new Date(`7/1/${currentAssessmentYearStart}`);
        });
    }

    filterCharacter(event, key: string) {
        const valueWithoutComma = event.target.value.split(',').join('');
        const regex = /^(-?\d*(\.\d*)?)$/;
        if (!regex.test(valueWithoutComma)) {
            this.taxInfoForm.get(key).patchValue(this.prevInputValues[key]);
        }
        else if (valueWithoutComma === '-' || valueWithoutComma === '-.' || valueWithoutComma === '.' || valueWithoutComma === '') {
            this.prevInputValues[key] = valueWithoutComma;
            this.taxInfoForm.get(key).patchValue(valueWithoutComma);
        }
        else if (valueWithoutComma.slice(valueWithoutComma.length - 1) === '.') {
            const valueWithComma = new Intl.NumberFormat('en-IN').format(parseFloat(valueWithoutComma)) + '.';
            this.prevInputValues[key] = valueWithComma;
            this.taxInfoForm.get(key).patchValue(valueWithComma);
        }
        else if (valueWithoutComma.slice(valueWithoutComma.length - 2, valueWithoutComma.length) === '.0') {
            const valueWithComma = new Intl.NumberFormat('en-IN').format(parseFloat(valueWithoutComma)) + '.';
            this.prevInputValues[key] = valueWithComma;
            this.taxInfoForm.get(key).patchValue(valueWithComma);
        }
        else if (!isNaN(valueWithoutComma)) {
            const valueWithComma = new Intl.NumberFormat('en-IN').format(parseFloat(valueWithoutComma));
            this.prevInputValues[key] = valueWithComma;
            this.taxInfoForm.get(key).patchValue(valueWithComma);
        }
    }
    checkSubmissionStatus() {
        this.multiApiService.getSubmissionIncludingDacon()
            .subscribe(res => {
            if (res.replyMessage === 'ONLINE') {
                this.getCertificateData('', true);
            }
            else if (res.replyMessage === 'APPROVED') {
                this.isShow = false;
                this.showTaxInfoModal('approved');
            }
            else if (res.replyMessage === 'PENDING') {
                this.isShow = false;
                this.modalRef = this.modalService.show(this.pendingStatusModal);
            }
            else if (res.replyMessage === 'NONE') {
                this.isShow = false;
                this.modalRef = this.modalService.show(this.nullStatusModal);
            }
            else if (res.replyMessage === 'ONLINE_PENDING') {
                this.isShow = false;
                this.toastr.error('Your return is in draft mode. Submit your return first.', '', { timeOut: 3000 });
            }
        }, error => {
            this.isShow = false;
        });
    }
    getZones() {
        this.apiService.get(environment.taxpayer_base_url + '/filingservice/v3/api/zones')
            .subscribe(res => {
            this.taxZones = res;
        }, error => {
        });
    }
    getCircles() {
        this.apiService.get(environment.taxpayer_base_url + '/filingservice/v3/api/circles/' + this.taxInfoForm.value.taxZone)
            .subscribe(res => {
            this.taxCircles = res;
        }, error => {
        });
    }
    onSelectZone() {
        this.taxInfoForm.get('taxCircle').patchValue(0);
        if (this.taxInfoForm.value.taxZone == 0) {
            this.taxCircles = [];
        }
        else {
            this.getCircles();
        }
    }
    showTaxInfoModal(statusType) {
        this.taxInfoForm.reset(this.initFormValue);
        this.status = statusType;
        if (this.modalRef) {
            this.modalRef.hide();
        }
        this.modalRef = this.modalService.show(this.taxInfoModal);
    }
    onRequestCertificate() {
        this.modalRef.hide();
        const totalIncome = !isNaN(this.taxInfoForm.value.totalIncome.split(',').join('')) ? this.taxInfoForm.value.totalIncome.split(',').join('') : '';
        const netWealth = !isNaN(this.taxInfoForm.value.netWealth.split(',').join('')) ? this.taxInfoForm.value.netWealth.split(',').join('') : '';
        const paidTax = !isNaN(this.taxInfoForm.value.paidTax.split(',').join('')) ? this.taxInfoForm.value.paidTax.split(',').join('') : '';
        const params = `?totalincome=${totalIncome}&netwealth=${netWealth}&paidtax=${paidTax}`;
        this.getCertificateData(params);
    }
    getPublicTaxCertificateData(): void {
        this.isApiLoading = true;
        this.apiService.get(environment.taxpayer_base_url + '/filingservice/v3/api/certificate/taxpayer/certificate-by-unique-key/get' + '?uniqueKey=' + this.uniqueKey)
        .subscribe(res => {
            this.isApiLoading = false;
            if (res?.success && res.replyMessage?.certificate) {
                this.returnResponse = res.replyMessage;
                this.isShow = true;
                this.totalAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.totalIncome));
                this.totalTaxAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.taxPaid));
                this.netWealthAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.netWealth));
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.uniqueKey;
                this.taxCheckBox = this.returnResponse?.taxPaid != null;
                this.incomeCheckBox = this.returnResponse?.totalIncome != null;
                this.netCheckBox = this.returnResponse?.netWealth != null;
                this.section = Object.values(SECTION_CONSTANTS)
                    .find(item => item.value === this.returnResponse?.section);
            } else {
                this.isShow = false;
            }
        }, error => {
            this.isApiLoading = false;
            this.isShow = false;
        });
    }
    getCertificateData(params, isOnline = false): void {
        let endPoint: string = '';
        if (isOnline) {
            endPoint = environment.taxpayer_base_url + '/filingservice/v3/api/certificate/taxpayer/tax-cert-and-ack-receipt-online/get?reportType=TAX_CERTIFICATE' + params;
        } else {
            endPoint = environment.taxpayer_base_url + '/filingservice/v3/api/certificate/taxpayer/tax-certificate' + params;
        }
        this.apiService.get(endPoint)
            .subscribe(res => {
                if (res?.success) {
                    this.returnResponse = res.replyMessage;
                    this.isShow = true;
                    let isOnlineKey = false;
                    this.totalAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.totalIncome));
                    this.totalTaxAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.taxPaid));
                    this.netWealthAmount = this.commaseparator.currencySeparatorBD(Math.round(this.returnResponse?.netWealth));
                    // this.taxpayerQRData = 'TIN:' + this.returnResponse?.tin + ', Reference No:' + this.returnResponse?.referenceNo;
                    this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.returnResponse?.certUniqueKey0;
                    Object.keys(this.returnResponse).forEach(key => {
                        if (key.includes('certUniqueKey')) {
                            this.listOfUniqueKeys.push({'key': key, 'value': this.returnResponse[key]});
                        }
                    });
                    for (let i = 0; i < this.listOfUniqueKeys.length; i++) {
                        if (this.listOfUniqueKeys[i].key.includes('certUniqueKey')) {
                            isOnlineKey = true;
                            break;
                        }
                    }
                    if (!isOnlineKey) {
                        this.taxpayerQRData = this.pathBaseUrl + 'submission-verification';
                    }
                    this.section = Object.values(SECTION_CONSTANTS)
                        .find(item => item.value === this.returnResponse?.section);
                }
            }, error => {
                this.isShow = false;
                if (this.modalRef) {
                    this.modalRef.hide();
                }
                this.modalRef = this.modalService.show(this.infoMismatchModal);
            });
    }
    onApplyForCertificate() {
        const zoneName = this.taxZones.filter(zone => zone.zoneNo == this.taxInfoForm.value.taxZone)[0].zoneName;
        const circleName = this.taxCircles.filter(circle => circle.circleNo == this.taxInfoForm.value.taxCircle)[0].circleName;
        const reqStatus = this.status == 'pending' ? 'APPROVAL_REQ' : (this.status == 'mismatched' ? 'EDIT_REQ' : 'ENTRY_REQ');
        const reqBody = {
            requestedCircleName: circleName,
            requestedCircleNo: Number(this.taxInfoForm.value.taxCircle),
            requestedZoneName: zoneName,
            requestedZoneNo: Number(this.taxInfoForm.value.taxZone),
            returnRegSlNo: this.taxInfoForm.value.returnRegSerial,
            submissionDate: this.datePipe.transform(this.taxInfoForm.value.submissionDate, 'dd-MM-yyyy'),
            submissionSection: this.taxInfoForm.value.submissionSection,
            totalIncome: (this.taxInfoForm.value.totalIncome === '-' || this.taxInfoForm.value.totalIncome === '.' || this.taxInfoForm.value.totalIncome == '-.') ? null : Number(this.commaseparator.removeComma(this.taxInfoForm.value.totalIncome, 3)),
            netWealth: (this.taxInfoForm.value.netWealth === '-' || this.taxInfoForm.value.netWealth === '.' || this.taxInfoForm.value.netWealth == '-.') ? null : Number(this.commaseparator.removeComma(this.taxInfoForm.value.netWealth, 3)),
            totalTaxPaid: (this.taxInfoForm.value.totalTaxPaid === '-' || this.taxInfoForm.value.totalTaxPaid === '.' || this.taxInfoForm.value.totalTaxPaid == '-.') ? null : Number(this.commaseparator.removeComma(this.taxInfoForm.value.paidTax, 3)),
            requestType: reqStatus
        };
        this.apiService.post(environment.taxpayer_base_url + '/filingservice/v3/api/taxpayer/certificate-req/', reqBody)
            .subscribe(res => {
            this.modalRef.hide();
            this.toastr.success('Your application request has been submitted successfully', '', {
                timeOut: 3000
            });
            this.router.navigateByUrl('/user-panel/tax-certificate-request');
        }, error => {
            this.modalRef.hide();
        });
    }
    closeModal() {
        this.modalRef.hide();
    }
    taxCertificateDownload() {
        let DATA = document.getElementById('income-tax-certificate');
        html2canvas(DATA).then(canvas => {
            let fileWidth = 208;
            let fileHeight = canvas.height * fileWidth / canvas.width;
            const FILEURI = canvas.toDataURL('image/png');
            let PDF = new jsPDF('p', 'mm', 'a4');
            let position = 0;
            PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
            PDF.save('Tax-Certificate-' + this.userTin);
        });
    }
    addWaterMark(doc) {
        var totalPages = doc.internal.getNumberOfPages();
        for (var i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setTextColor(150);
            doc.setFontSize(20);
            doc.text(75, doc.internal.pageSize.height - 70, 'Dummy Version', null, 30);
        }
        return doc;
    }
    getMessage(): string {
        if (this.incomeCheckBox && this.netCheckBox && this.taxCheckBox) {
            return ` Shown Total Income ${this.totalAmount} BDT, Net Wealth ${this.netWealthAmount} BDT and Paid Tax ${this.totalTaxAmount} BDT.`;
        }
        else if (this.incomeCheckBox && this.netCheckBox && !this.taxCheckBox) {
            return ` Shown Total Income ${this.totalAmount} BDT and Net Wealth ${this.netWealthAmount} BDT.`;
        }
        else if (this.incomeCheckBox && !this.netCheckBox && this.taxCheckBox) {
            return ` Shown Total Income ${this.totalAmount} BDT and Paid Tax ${this.totalTaxAmount} BDT.`;
        }
        else if (!this.incomeCheckBox && this.netCheckBox && this.taxCheckBox) {
            return ` Shown Net Wealth ${this.netWealthAmount} BDT and Paid Tax ${this.totalTaxAmount} BDT.`;
        }
        else if (this.incomeCheckBox && !this.netCheckBox && !this.taxCheckBox) {
            return ` Shown Total Income ${this.totalAmount} BDT.`;
        }
        else if (!this.incomeCheckBox && this.netCheckBox && !this.taxCheckBox) {
            return ` Shown Net Wealth ${this.netWealthAmount} BDT.`;
        }
        else if (!this.incomeCheckBox && !this.netCheckBox && this.taxCheckBox) {
            return ` Paid Tax ${this.totalTaxAmount} BDT.`;
        }
    }
    ngOnDestroy(): void {
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }

    onChangeCheckBox() {
        let isOnline = false;
        for (let i = 0; i < this.listOfUniqueKeys.length; i++) {
            if (this.listOfUniqueKeys[i].key.includes('certUniqueKey')) {
                isOnline = true;
                break;
            }
        }
        if (!isOnline) {
            this.taxpayerQRData = this.pathBaseUrl + 'submission-verification';
        } else {
            if (!this.incomeCheckBox && !this.netCheckBox && !this.taxCheckBox) {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey0')?.value;
            } else if (!this.incomeCheckBox && !this.netCheckBox && this.taxCheckBox) {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey1')?.value;
            } else if (!this.incomeCheckBox && this.netCheckBox && !this.taxCheckBox) {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey2')?.value;
            } else if (!this.incomeCheckBox && this.netCheckBox && this.taxCheckBox) {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey3')?.value;
            } else if (this.incomeCheckBox && !this.netCheckBox && !this.taxCheckBox) {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey4')?.value;
            } else if (this.incomeCheckBox && !this.netCheckBox && this.taxCheckBox) {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey5')?.value;
            } else if (this.incomeCheckBox && this.netCheckBox && !this.taxCheckBox) {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey6')?.value;
            } else {
                this.taxpayerQRData = this.pathBaseUrl + 'tax-certificate' + '?key=' + this.listOfUniqueKeys.find(item => item.key === 'certUniqueKey7')?.value;
            }
        }
    }
}
